import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppModalService } from '@datachain/ui-sdk/components/app-modal';
import { catchError, Observable, throwError } from 'rxjs';

import {
	AppUpdateReportComponent,
	ColumnUsageReport,
	SubscriptionColumnUpdateReport,
} from '../../ui/components/app-update-report/app-update-report.component';

type UpdateErrorPayload = {
	code?: string;
	message?: string;
	args?: ReadonlyArray<{
		blocked_columns?: ReadonlyArray<{
			column_label?: string;
			column_uuid?: string;
			column_templates?: ReadonlyArray<{ uuid?: string; label?: string }>;
			filters?: ReadonlyArray<{ uuid?: string; label?: string }>;
		}>;
	}>;
};

@Injectable()
export class DcSubscriptionUpdateColumnsErrorInterceptor
	implements HttpInterceptor
{
	public constructor(private readonly modalService: AppModalService) {}

	public intercept(
		req: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			catchError((responseErr: HttpErrorResponse) => {
				if (req.method === 'PUT' && responseErr?.error?.code === '05') {
					this.modalService.openPopup<SubscriptionColumnUpdateReport>(
						AppUpdateReportComponent,
						{
							title: $localize`:i18n=@@update.report:`,
							subTitle: '',
							width: '500px',
							height: '50%',
							code: 5,
							msg: responseErr?.error?.message ?? 'Unable to update',
							elements: this.adapt(responseErr.error),
						},
						{
							disableClose: false,
						}
					);
				}
				return throwError(() => responseErr);
			})
		);
	}

	private adapt(errorResponse: UpdateErrorPayload): Array<ColumnUsageReport> {
		return (
			errorResponse.args?.flatMap(
				(a) =>
					a.blocked_columns?.map<ColumnUsageReport>((el) => ({
						label: el?.column_label ?? 'N/A',
						uuid: el?.column_uuid ?? 'N/A',
						type: 'column',
						colTemplates: el.column_templates
							? el.column_templates.map((clt) => ({
									type: 'columnTemplate',
									label: clt.label ?? 'N/A',
									uuid: clt.uuid ?? 'N/A',
							  }))
							: [],
						filterTemplates: el.filters
							? el.filters.map((clt) => ({
									type: 'filterTemplate',
									label: clt.label ?? 'N/A',
									uuid: clt.uuid ?? 'N/A',
							  }))
							: [],
					})) ?? []
			) ?? []
		);
	}
}
